import React from "react";
import PropTypes from "prop-types";
import {Grid, Box} from "@material-ui/core";
import * as Sentry from "@sentry/react";
import {useI18N} from "../../../common/common";
import LoadingView from "../../widget/loading/LoadingView";
import ReservationCard from "./ReservationCard";


const ReservationsGrid = ({reservations, noResultsComponent}) => {
    const {i18n} = useI18N();

    return (
        <>
            {reservations && reservations.length ? (
                <Grid
                    container
                    spacing={2}
                >
                    {reservations.map((reservation, index) => (
                        <Sentry.ErrorBoundary
                            key={index}
                            fallback={null}
                        >
                            <Grid
                                item
                                lg={4}
                                md={6}
                                sm={6}
                                xs={12}
                            >
                                <Box
                                    mb={2}
                                    height="100%"
                                >
                                    <ReservationCard
                                        reservation={reservation}
                                    />
                                </Box>
                            </Grid>
                        </Sentry.ErrorBoundary>
                    ))}
                </Grid>
            ) : (reservations && noResultsComponent)}
            <LoadingView
                isLoading={!reservations}
                title={i18n("common.label.loading_your_data")}
            />
        </>
    );
};

ReservationsGrid.propTypes = {
    reservations: PropTypes.any,
    noResultsComponent: PropTypes.element
};

export default ReservationsGrid;
